import React from 'react';
import renaud from '../assets/self/renaud.jpg';
import moi from '../assets/self/moi.jpg';

const Ouvert = () => {
  const features = [
    {
      image: renaud,
      title: "Réflexes",
      description: "Venez acquérir des réflexes de base pour prévenir les ennuis, les éviter, pour ainsi sortir sans problème d'une situation potentiellement dangereuse",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
        </svg>
      )
    },
    {
      image: moi,
      title: "Ouvert à tous",
      description: "Tout le monde peut venir. Les conseils sont personnalisés en fonction de la situation de chacun",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"></path>
        </svg>
      )
    }
  ];

  return (
    <section className="relative py-20 bg-gradient-to-br from-white via-gray-50 to-white overflow-hidden">
      {/* Éléments décoratifs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-primary/5 to-red-100/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-gradient-to-tr from-red-50/30 to-primary/5 rounded-full blur-3xl"></div>
      
      <div className="relative container mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-primary to-red-600 text-white text-sm font-semibold rounded-full mb-6">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
            </svg>
            Nos avantages
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Des cours 
            <span className="text-primary"> accessible</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Notre approche inclusive permet à chacun de progresser selon ses capacités et ses objectifs.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" 
                  src={feature.image} 
                  alt={feature.title} 
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent"></div>
                
                {/* Icône flottante */}
                {/* <div className="absolute top-4 right-4 w-12 h-12 bg-gradient-to-r from-primary to-red-600 rounded-full flex items-center justify-center text-white shadow-lg">
                  {feature.icon}
                </div> */}
                
                {/* Badge */}
                <div className="absolute bottom-4 left-4">
                  <div className="px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full">
                    <span className="text-sm font-semibold text-gray-900">{feature.title}</span>
                  </div>
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  {/* <span className="w-8 h-8 bg-gradient-to-r from-primary to-red-600 rounded-full flex items-center justify-center text-white text-sm mr-3">
                    {index + 1}
                  </span> */}
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6">
                  {feature.description}
                </p>
                
                {/* Call to action */}
                <a 
                  href="#contact"
                  className="inline-flex items-center text-primary font-semibold hover:text-red-600 transition-colors duration-300"
                >
                  <span>En savoir plus</span>
                  <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Section complémentaire */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-primary to-red-600 rounded-3xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">Une approche personnalisée</h3>
            <p className="text-gray-100 mb-6 max-w-2xl mx-auto">
              Que vous soyez débutant ou expérimenté, nos instructeurs s'adaptent à votre niveau 
              et vos objectifs pour vous offrir un apprentissage optimal.
            </p>
            <a 
              href="#contact"
              className="inline-flex items-center px-6 py-3 bg-white text-primary font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              <span>Essayer un cours</span>
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ouvert;